import { render, staticRenderFns } from "./DSTextarea.vue?vue&type=template&id=0c1d2baf&scoped=true&"
import script from "./DSTextarea.vue?vue&type=script&lang=ts&"
export * from "./DSTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./DSTextarea.vue?vue&type=style&index=0&id=0c1d2baf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d2baf",
  null
  
)

export default component.exports